<script setup>const route=useRoute();</script><template><RatingDirectory :key="String(route.params.subcategory)" :category-slug="String(route.params.subcategory)" /></template>
